'use strict';
// TODO: Remove from `core-js@4`
var defineWellKnownSymbol = require('../internals/well-known-symbol-define');

// `Symbol.metadataKey` well-known symbol
// https://github.com/tc39/proposal-decorator-metadata
defineWellKnownSymbol('metadataKey');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/esnext.symbol.metadata-key.js
// module id = 1524
// module chunks = 0